import { render, staticRenderFns } from "./CourseRegisterDetailsPage.vue?vue&type=template&id=709056fa&scoped=true&"
import script from "./CourseRegisterDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CourseRegisterDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709056fa",
  null
  
)

export default component.exports